module.exports = __webpack_public_path__ + "static/media/logo.d8976e84.png";